import { Controller } from '@hotwired/stimulus'

// Mirrors the Lead model validations for instant feedback;
// the server remains the source of truth.
const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export default class extends Controller {
  static targets = ['field']

  connect () {
    // Native bubbles are replaced by inline errors below
    this.element.setAttribute('novalidate', 'novalidate')
  }

  validate ({ target }) {
    this.#validateField(target)
  }

  revalidate ({ target }) {
    // While typing, only update fields that already show an error
    if (target.getAttribute('aria-invalid') === 'true' || target.classList.contains('field_with_errors')) {
      this.#validateField(target)
    }
  }

  validateAll (event) {
    const invalidFields = this.fieldTargets.filter(field => !this.#validateField(field))

    if (invalidFields.length > 0) {
      event.preventDefault()
      invalidFields[0].focus()
    }
  }

  #validateField (field) {
    const message = this.#errorMessageFor(field)
    this.#toggleError(field, message)

    return !message
  }

  #errorMessageFor (field) {
    // Fields inside a disabled fieldset are hidden and not submitted
    if (field.matches(':disabled')) return null

    const value = field.value.trim()

    if (field.required && !value) return "Can't be blank"
    if (field.type === 'email' && value && !EMAIL_REGEXP.test(value)) return 'Should look like an email address'

    return null
  }

  #toggleError (field, message) {
    let errorElement = field.parentElement.querySelector('.contact-form__error')

    if (message) {
      if (!errorElement) {
        errorElement = document.createElement('p')
        errorElement.classList.add('contact-form__error')
        field.parentElement.appendChild(errorElement)
      }
      errorElement.textContent = message
      field.classList.add('contact-form__input--error')
      field.setAttribute('aria-invalid', 'true')
    } else {
      if (errorElement) errorElement.remove()
      field.classList.remove('contact-form__input--error', 'field_with_errors')
      field.removeAttribute('aria-invalid')
    }
  }
}
